import React, { Component } from "react";
import { Card, CardBody, CardTitle } from "reactstrap";
import Chart from "react-apexcharts";
import Spinner from "../../shared/components/scrollbar/lib/spinner";
import { appHelpers } from "../../_helpers";
import "./style.css";

class AreaChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colors: ["#FF794F"],
    };
  }

  onChartCreated = (chart) => {
    chart.updateOptions({
      colors: this.state.colors,
    });
  };

  extractAirline = () => {
    const { areaChartData } = this.props;
    return areaChartData ? areaChartData.map((item) => item.Name) : [];
  };

  extractPassengers = () => {
    const { areaChartData } = this.props;
    return areaChartData ? areaChartData.map((item) => item.Count) : [];
  };

  render() {
    const { title, areaChartData } = this.props;

    const series = [
      {
        name: "avicollect-chart",
        data: [...this.extractPassengers()],
      },
    ];

    const options = {
      chart: {
        id: "avicollect-chart",
        type: "area",
        height: 350,
        zoom: {
          enabled: false,
        },
        stroke: {
          curve: "zigzag",
        },
        fill: {
          opacity: 1,
        },
        events: {
          created: this.onChartCreated,
        },
      },
      colors: this.state.colors,
      labels: this.extractAirline(),
      xaxis: {
        categories: [...this.extractAirline()],
      },
      yaxis: {
        lines: {
          show: true, // Show the vertical grid lines
        },
      },
    };

    return (
      <Card className="pb-3" style={{ backgroundColor: "#FBFBFB" }}>
        <CardBody>
          <CardTitle className="text-left pb-4">{title}</CardTitle>
          <div className="area-chart-container">
            {!areaChartData ? (
              <center>
                <div>No Data </div>
              </center>
            ) : (
              <Chart
                options={options}
                series={series}
                type="area"
                width={900}
                height={300}
              />
            )}
          </div>
        </CardBody>
      </Card>
    );
  }
}

export default AreaChart;



// WEBPACK FOOTER //
// ./src/views/avicollectDashboard/area-chart.js